module.exports = __webpack_public_path__ + "static/media/verified.9a5d69ad.svg";